// extracted by css-extract-rspack-plugin
export default {"customer":"wz2uGB","userlink":"j_eRwE","menu-wrapper":"oh3mWY","menuWrapper":"oh3mWY"};